import * as Yup from 'yup';

const authValidation = (t: (key: string) => string) => ({
  login: Yup.object().shape({
    username: Yup.string().required(t('validation.userNameRequired')),
    password: Yup.string().required(t('validation.passwordRequired')),
  }),
  forgotPassword: Yup.object().shape({
    phone: Yup.string()
      .matches(/^[0-9]{10}$/, t('validation.phoneInvalid'))
      .required(t('validation.phoneRequired')),
  }),
  resetPassword: Yup.object().shape({
    password: Yup.string().required(t('validation.passwordRequired')).min(6, t('validation.passwordMinLength')),
    confirmPassword: Yup.string()
      .oneOf([Yup.ref('password'), undefined], t('validation.passwordMismatch'))
      .required(t('validation.confirmPasswordRequired'))
      .min(6, t('validation.passwordMinLength')),
  }),
  changePassword: Yup.object().shape({
    current_password: Yup.string().required(t('validation.current_password_required')),
    new_password: Yup.string()
      .required(t('validation.new_password_required'))
      .notOneOf([Yup.ref('current_password')], t('validation.new_password_must_different')),
    confirm_password: Yup.string()
      .required(t('validation.confirm_password_required'))
      .oneOf([Yup.ref('new_password')], t('validation.password_not_match')),
  }),
});

export default authValidation;
